<app-auth-modal-shell *ngIf="isVisible" title="Log In" (closed)="closeModal()">
  <form class="login-modal__form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <app-auth-email-field [control]="loginForm.controls.email" />

    <app-auth-password-field [control]="loginForm.controls.password" />

    <div *ngIf="errorMessage" class="login-modal__error" role="alert">
      <p class="login-modal__error-text">{{ errorMessage }}</p>
      <p *ngIf="wrongVanityPortalUrl" class="login-modal__error-link-text">
        Go to
        <a class="login-modal__portal-link" [href]="wrongVanityPortalUrl">{{ wrongVanityPortalUrl }}</a>
      </p>
    </div>

    <p class="login-modal__forgot-password-text">
      Forgot Password?
      <span class="login-modal__forgot-password-link" (click)="openResetPassword()">Update</span>
    </p>

    <app-button variant="main" size="lg" [disabled]="isFormInvalid" [fullWidth]="true">
      <span *ngIf="isLoading" class="app-spinner app-spinner--on-inverse"></span>
      <span *ngIf="!isLoading">LOGIN</span>
    </app-button>

    <p class="login-modal__register-text" *ngIf="!isVanityHost">
      Don't have an account?
      <span class="login-modal__register-link" (click)="openSignUp()">Become a member</span>
    </p>
  </form>
</app-auth-modal-shell>
